module.exports = __webpack_public_path__ + "img/pakiet-pszczelego-bohatera-poziom.095517ea.jpg";